var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLedgerLogo = function SvgLedgerLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2E3E",
    fillRule: "evenodd",
    d: "M15 0h17.8A7.2 7.2 0 0 1 40 7.2V25H15zM0 10V7.2A7.2 7.2 0 0 1 7.2 0H10v10zm10 30H7.2A7.2 7.2 0 0 1 0 32.8V30h10zm30-10v2.8a7.2 7.2 0 0 1-7.2 7.2H30V30zm-25 0h10v10H15zM0 15h10v10H0z"
  })));
};
export default SvgLedgerLogo;